import { addDays, key, startOfDay } from './dates';
import type { Award, Days, Track } from './types';

export function runTrack(
  days: Days,
  track: Track,
  target: number,
  rate: number,
  from: Date,
  to: Date
): { streak: number; awards: Award[] } {
  let streak = 0;
  const awards: Award[] = [];
  const goal = Math.max(1, target);
  for (let d = startOfDay(from); d <= to; d = addDays(d, 1)) {
    const v = days[key(d)]?.[track];
    if (v === 'green') {
      streak += 1;
      if (streak >= goal) {
        awards.push({ date: key(d), amount: goal * rate });
        streak = 0;
      }
    } else if (v === 'red') {
      streak = 0;
    }
  }
  return { streak, awards };
}

export function runPerfect(days: Days, from: Date, to: Date): number {
  let streak = 0;
  for (let d = startOfDay(from); d <= to; d = addDays(d, 1)) {
    const e = days[key(d)] || {};
    if (e.home === 'green' && e.school !== 'red') {
      streak += 1;
    } else if (e.home === 'red' || e.school === 'red') {
      streak = 0;
    }
  }
  return streak;
}
